import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { onboardingPlanRatesApi } from "./api";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { useSmartQuery } from "@shared/api/queries/hooks";


export const useRecentlyUpdatedRates = (limit: number = 3) => {
  const remoteUtilityId = useRemoteUtilityId();
  const enabled = !!remoteUtilityId;

  return useSmartQuery(
    QueryKeyFactory.module.onboarding.planRates.recentlyUpdatedRates(limit),
    () => onboardingPlanRatesApi.getRecentlyUpdatedRates(remoteUtilityId, limit),
    { enabled }
  );
};

export const useRecentlyUpdatedPlans = (limit = 3) => {
  const remoteUtilityId = useRemoteUtilityId();
  const enabled = !!remoteUtilityId;

  return useSmartQuery(
    QueryKeyFactory.module.onboarding.planRates.recentlyUpdatedPlans(limit),
    () => onboardingPlanRatesApi.getRecentlyUpdatedPlans(remoteUtilityId, limit),
    { enabled }
  );
};

export const usePlanDashboard = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const enabled = !!remoteUtilityId;

  return useSmartQuery(
    QueryKeyFactory.module.onboarding.planRates.planKPIs(),
    () => onboardingPlanRatesApi.getPlanDashboardData(remoteUtilityId),
    { enabled }
  );
};
